import React from 'react';
import './EdutoryCourseCard.css';

const EdutoryCourseCard = ({ course }) => {
  const getLevelColor = (level) => {
    switch (level?.toLowerCase()) {
      case 'beginner':
        return 'course-level-beginner';
      case 'intermediate':
        return 'course-level-intermediate';
      case 'advanced':
        return 'course-level-advanced';
      case 'professional':
        return 'course-level-professional';
      default:
        return 'course-level-default';
    }
  };

  return (
    <div className="edutory-course-card">
      <div className="course-header">
        <div className="course-icon-wrapper">
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="course-icon"
          >
            <path
              d="M12 14L21 9L12 4L3 9L12 14Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 14L21 9V16C21 16 19 18 12 18C5 18 3 16 3 16V9L12 14Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="course-meta">
          <span className={`course-level-badge ${getLevelColor(course.level)}`}>
            {course.level}
          </span>
          {course.duration && (
            <span className="course-duration">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              {course.duration}
            </span>
          )}
        </div>
      </div>

      <h4 className="course-title">{course.title}</h4>

      <div className="course-footer">
        <div className="course-provider">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
          </svg>
          {course.provider}
        </div>
        <a
          href={course.url}
          target="_blank"
          rel="noopener noreferrer"
          className="course-link-btn"
        >
          Enroll Now
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default EdutoryCourseCard;
